import AnamnesisView, { Views as ANAMNESIS_VIEWS } from 'components/organisms/Anamnesis';
import i18n from 'helper/i18n';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, Dispatch } from 'redux';
import { actionCreators, getTempAcceptedPregnancyWarning, getTempPregnant } from 'store/profile';
import { IRootState } from 'store/rootReducer';
import { WithRouterType } from 'types/withRouter';
import { mapParentStateToProps } from '../Anamnesis';

const mapStateToProps = (state: IRootState, props: WithRouterType) => ({
	...mapParentStateToProps(state, props),
	currentStep: ANAMNESIS_VIEWS.SELECT_GENDER,
	introTitle: i18n('react.impulsCoach.components.anamnesis.selectGender.introTitle'),
	introText: i18n('react.impulsCoach.components.anamnesis.selectGender.introText'),
	title: i18n('react.impulsCoach.components.anamnesis.selectGender.title'),
	isPregnant: getTempPregnant(state),
	acceptedWarnHint: getTempAcceptedPregnancyWarning(state),
	genders: [
		{
			name: 'M' as 'M',
			labelText: i18n('react.impulsCoach.components.GenderSelector.labelText.male'),
		},
		{
			name: 'F' as 'F',
			labelText: i18n('react.impulsCoach.components.GenderSelector.labelText.female'),
		},
	],
});

const mapDispatchToProps = (dispatch: Dispatch) => {
	return bindActionCreators(actionCreators, dispatch);
};

export type SelectGenderContainerProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AnamnesisView) as any);
